// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2keUz","content":"styles_content__1heOv","checkbox":"styles_checkbox__3hfXA","checkboxLabel":"styles_checkboxLabel__JybKS"};